import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Stack
} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import RelatedLocationHistory from "../LocationHistory/RelatedLocationHistory";
// import RelatedListFiles from "../File/RelatedListFiles";
import PubSub from "pubsub-js";
// import UserTracking from "../Project/UserTracking";
// import FilesCreate from "../File/FilesCreate";
import solisPowerApi from "../../api/solisPowerApi";
import { ROUTES } from "../../constants/webRouting";
import PERMISSIONS from "../../constants/permissions";
import { getUserDetails } from "../../utils/helper";

const UserView = () => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();

  const [user, setUser] = useState(location.state ? location.state : {});
  // const [userTracking, setuserTracking] = useState( location.state ? location.state : {} );
  // const [locationHistorysTab, setLocationHistorysTab] = useState(true);
  // const [filesTab, setFilesTab] = useState(true);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  //console.log('user', user)
  // const [refreshFileList, setRefreshFileList] = useState();
  // const [refreshProductvarientList, setRefreshProductvarientList] = useState();
  // const [modalShowProductvarient, setModalShowProductvarient] = useState(false);
  // const [relatedListProductvarient, setRelatedListProductvarient] = useState(true);
  // const [relatedListStock, setRelatedListStock] = useState(false);
  // const [relatedListFiles, setRelatedListFiles] = useState(false);
  // const [modalShowProductvarientfile, setModalShowFile] = useState(false);
  const [files, setFiles] = useState([]);

  // const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    fetchUserById();
    // filesList();
  }, []);

  // const filesList = () => {
  //   async function init() {
  //     //let file = await WhiteObjectApi.fetchFiles(userTracking.id);
  //     // let file = await solisPowerApi.fetchFiles(user.id);
  //     let file = null;
  //     if (file && file?.length > 0) {
  //       setFiles(file);
  //     } else {
  //       setFiles([]);
  //     }
  //   }
  //   init();
  // };

  // const submitfiles = () => {
  //   setModalShowFile(false);
  //   setRefreshFileList(Date.now());
  //   filesList();
  // };

  // const submitProductvarients = () => {
  //   setModalShowProductvarient(false);
  //   // setRefreshProductvarientList(Date.now());
  // };

  const handlePasswordOnchange = (e) => {
    //console.log(e.target.value)
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const fetchUserById = () => {
    if (
      location.hasOwnProperty("pathname") &&
      location.pathname.split("/").length >= 3
    ) {
      user.id = location.pathname.split("/")[2];
      //console.log('user.id',user.id)
    }

    async function inituser() {
      let result = await solisPowerApi.fetchUserById(user.id);
      console.log("result fetch by id", result);
      setUser(result);
    }
    inituser();
  };

  const editUser = (row) => {
    //console.log("row", row);
    navigate(`/users/${user.id}/e`, { state: user });
  };

  // const handleSelect = (key) => {
  //   if (key === "login history") {
  //     setLocationHistorysTab(true);
  //     //setFilesTab(false)
  //     setRelatedListFiles(false);
  //   } else if (key === "user track") {
  //     //setFilesTab(true);  //setRelatedListFiles
  //     setLocationHistorysTab(false);
  //     setRelatedListFiles(true);
  //     //setRelatedListStock(false);
  //   }
  // };

  const handleChangeSubmit = async (e) => {
    //console.log('user', user);

    e.preventDefault();
    //console.log('userId', userId);
    console.log("user", user);

    if (user.password === user.confirmpassword && user.password !== "") {
      let newUser = { id: user.id, password: user.password };
      const result = await solisPowerApi.saveUser(newUser);
      setShowPasswordModal(false);
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record Saved",
        message: "Password updated successfully",
      });
      //console.log('result', result);
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record Saved Error",
        message: "Either password do not match or not entered",
      });
      //console.log('Password is null, please enter a valid password.');
    }
  };

  const handleClose = () => setShowPasswordModal(false);

  return (

    <Container>
      <Modal
        show={showPasswordModal}
        onHide={handleClose}
        className="modal-sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col></Col>
            <Col lg={12}>
              <Form className="mt-3">
                <Row>
                  <Col>
                    <Form.Group
                      className="mx-3"
                      controlId="formBasicFirstName"
                    >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        New Password
                      </Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        placeholder="Enter Your password"
                        onChange={handlePasswordOnchange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mx-3" controlId="formBasicPhone">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPhone"
                      >
                        Confirm Password
                      </Form.Label>
                      <Form.Control
                        type="password"
                        name="confirmpassword"
                        placeholder="Enter confirm password"
                        onChange={handlePasswordOnchange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col></Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleChangeSubmit}>
            Save
          </Button>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Row className="view-form">
        <Col lg={12} className="">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>Home</Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.USER.LIST)} >Users</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col lg={12} className=" ">

          <Card className="shadow">
            <CardHeader className="bg-custom text-white">
              <Row className="w-100"  >
                <Col lg={6} className="" >
                  <div className="d-flex align-items-center h-100 gap-3" >
                    <h5 className="m-0">
                      User
                    </h5>
                    <h5 className="m-0">
                      {`${user.firstname || ""} ${user.lastname || ""}`}
                    </h5>
                  </div>
                </Col>
                <Col lg={6} className="p-0" >

                  <Stack direction="horizontal" className="float-end" gap={2}>
                    {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_USER].some(permission => {
                      return userInfo?.permissions.map(p => p.name).includes(permission);
                    }) && (
                        <Button
                          size="sm"
                          className="btn-edit"
                          onClick={() => editUser(true)}
                        >
                          <i className="fa-regular fa-pen-to-square"></i>
                        </Button>
                      )}
                    {([PERMISSIONS.MODIFY_ALL].some(permission => {
                      return userInfo?.permissions.map(p => p.name).includes(permission);
                    }) || userInfo.id === user.id) && (
                        <Button
                          size="sm"
                          className="btn-reset-password"
                          onClick={(e) => {
                            setShowPasswordModal(true);
                          }}
                        >
                          Reset Password
                        </Button>
                      )}
                    {/* {Permissionhelper.checkPermission(
                        constants.SUPER_ADMIN
                      ) && (
                          <Button
                            size="sm"
                            className="btn-delete"
                            onClick={() => setModalShow(true)}
                          >
                            <i className="fa fa-trash-o"></i>
                          </Button>
                        )} */}
                  </Stack>

                </Col>
              </Row>
            </CardHeader>
            <CardBody className="">
              <Row className="ibs-edit-form py-3">
                <Col lg={6}>
                  <label>First Name</label>
                  <span>{user.firstname}</span>
                </Col>
                <Col lg={6}>
                  <label>Last Name</label>
                  <span>{user.lastname}</span>
                </Col>
                <Col lg={6}>
                  <label>Email</label>
                  <span>{user.email}</span>
                </Col>
                <Col lg={6}>
                  <label>Phone</label>
                  <span>{user.phone}</span>
                </Col>
                <Col lg={6}>
                  <label>User Type</label>
                  <span>{user.userrole}</span>
                </Col>
                <Col lg={6}>
                  <label>User Category</label>
                  <span>{user.user_type}</span>
                </Col>
                <Col lg={6}>
                  <label>Manager</label>
                  <span>{user.managername}</span>
                </Col>
                <Col lg={6}>
                  <label>Active</label>
                  <span>
                    {user.isactive === true && (
                      <i
                        className="fa-regular fa-square-check"
                        style={{ fontSize: "1.3rem" }}
                      ></i>
                    )}{" "}
                    {user.isactive === false && (
                      <i
                        className="fa-regular fa-square"
                        style={{ fontSize: "1.3rem" }}
                      ></i>
                    )}{" "}
                  </span>
                </Col>
              </Row>
            </CardBody>
          </Card>

        </Col>
      </Row>

    </Container>

  );
};

export default UserView;
